import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { motion } from 'framer-motion';
import './AuthForm.css'; // <--- Ensure this is imported here!

export default function AuthForm({ initialMode = false }) {
  const [isSignup, setIsSignup] = useState(initialMode);
  const [formLoading, setFormLoading] = useState(false);
  
  const navigate = useNavigate();
  const { signInWithGoogle } = useAuth();

  const handleGoogleLogin = async () => {
    setFormLoading(true);
    try {
      const userData = await signInWithGoogle();
      // Logic is clean: if not onboarded, go to onboarding, else dashboard
      const path = userData.onboarded ? `/dashboard/${userData.uid}` : `/onboarding/${userData.uid}`;
      navigate(path);
    } catch (err) {
      console.error(err);
      alert("System Initialization Failed");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="auth-card">
        <h1 className="auth-title">{isSignup ? 'S I G N U P' : 'L O G I N'}</h1>
        
        {/* Render your inputs here similarly to your past project */}
        
        <button 
          onClick={handleGoogleLogin} 
          disabled={formLoading} 
          className="google-btn"
        >
          {formLoading ? 'PROCESSING...' : 'Login WITH GOOGLE'}
        </button>

        <motion.p 
  className="toggle-auth" 
  onClick={() => setIsSignup(!isSignup)}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
>
  {isSignup ? 'Already in? Login' : 'Newbie? Signup'}
</motion.p>
      </motion.div>
    </div>
  );
}